// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2KKY8","inner":"Footer_inner___Bb8g"};